import ApiClient from '@/services/apiClient';

// Door of a third-party access control system mirrored as a reader of the LINK (HAXO Fusion).
// Set by the integration of the LINK, read-only in the configuration
export default class HaxoFusionConfig {
  provider;     // 'Spc'
  panel_id;     // id of the panel in the integration configuration
  door_id;      // id of the door on that system

  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HaxoFusionConfig();
      obj.provider = ApiClient.convertToType(data['provider'], 'String');
      obj.panel_id = ApiClient.convertToType(data['panel_id'], 'String');
      obj.door_id = ApiClient.convertToType(data['door_id'], 'Integer');
    }
    return obj;
  }

  get is_spc() {
    return this.provider === 'Spc';
  }
}
